import type { ZudokuConfig } from 'zudoku';
import { SignupOrKeys } from './SignupOrKeys';

const config: ZudokuConfig = {
  canonicalUrlOrigin: 'https://api.rewiringamerica.org',
  basePath: '',
  mdx: {
    components: { SignupOrKeys },
  },
  defaults: {
    apis: {
      examplesLanguage: 'shell', // Default language for code examples
      disablePlayground: false, // Disable the interactive API playground
      showVersionSelect: 'if-available', // Control version selector visibility
      expandAllTags: true, // Control initial expanded state of tag categories
    },
  },
  navigation: [
    {
      type: 'category',
      label: 'Documentation',
      icon: 'book',
      items: [
        {
          type: 'doc',
          file: 'introduction',
          label: 'Introduction',
          icon: 'star',
        },
        {
          type: 'doc',
          file: 'upgrades',
          label: 'Home Upgrades',
          icon: 'lightbulb',
        },
        {
          type: 'category',
          label: 'Embed our Calculators',
          icon: 'square-square',
          items: ['rem/embed', 'incentives/embed'],
        },
        {
          type: 'category',
          label: 'Incentives Info',
          icon: 'wallet',
          // Leaving this as a static array as we can control ordering this way
          items: [
            'incentives/changelog',
            'incentives/items',
            'incentives/geo_handling',
          ],
        },
      ],
    },
    {
      type: 'link',
      to: '/api',
      label: 'API Reference',
      icon: 'code',
      description: 'Complete API documentation',
      badge: {
        label: 'v2.0',
        color: 'blue',
      },
      display: 'always',
    },
  ],
  site: {
    title: 'API Documentation',
    logo: {
      src: {
        light: '/logos/RA_logo_2024_black.png',
        dark: '/logos/RA_logo_2024_white.png',
      },
      width: '120px',
    },
  },
  redirects: [
    { from: '/', to: '/introduction' },
    // Redirect away from our old documentation
    // Upgrades Doc
    { from: '/docs/routes/upgrades', to: '/upgrades' },
    // Incentives Docs
    { from: '/docs/routes/items', to: '/incentives/items' },
    { from: '/docs/routes/embed', to: '/incentives/embed' },
    { from: '/docs/routes/roadmap', to: '/incentives/roadmap' },
    { from: '/docs/routes/changelog', to: '/incentives/changelog' },
    { from: '/docs/routes/geo_handling', to: '/incentives/geo_handling' },
    // API response definitions
    { from: '/docs/routes/responses', to: '/api/~schemas' },
    // General Redirection to landing page
    { from: '/docs', to: '/introduction' },
    // Looking for APIs? You're getting some incentives 💵
    { from: '/api', to: '/incentives' },
  ],
  apis: [
    {
      path: '/api',
      type: 'file',
      input: '../config/routes.oas.json',
    },
  ],
  metadata: {
    title: "Rewiring America API's",
    description:
      'This webiste hosts the API endpoints created by Rewiring America.',
    logo: 'https://www.rewiringamerica.org/logo.svg',
    favicon: 'https://www.rewiringamerica.org/favicon.ico',
    publisher: 'Rewiring America',
    generator: 'Website Generator 1.0',
    applicationName: 'Rewiring America API',
    referrer: 'no-referrer',
    keywords: ['electrification', 'heat pump', 'incentives', 'energy modeling'],
    authors: [''],
    creator: 'Rewiring America',
  },
  authentication: {
    type: 'auth0',
    // Zudoku only uses the hostname; remove the "https://" prefix from the Zuplo variable.
    domain: new URL(process.env.ZUPLO_PUBLIC_AUTH0_AUTHORITY_URL).hostname,
    clientId: process.env.ZUPLO_PUBLIC_AUTH0_CLIENT_ID,
    scopes: ['openid', 'profile', 'email', 'custom_scope'],
    audience: process.env.ZUPLO_PUBLIC_AUTH0_AUDIENCE_URL,
  },
  protectedRoutes: [
    '/api/*/internal/*', // Potentially hide all internal use API endpoints, CURRENTLY NOT BEING USED
  ],
  apiKeys: { enabled: true },
};

export default config;
